import React, { useState, useEffect } from 'react';
import { motion, useScroll } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import AudienceStrip from './components/AudienceStrip';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ContactPage from './pages/ContactPage';
import ServiceDetailsPage from './pages/ServiceDetailsPage';
import PricingPage from './pages/PricingPage';
import CursorGlow from './components/ui/CursorGlow';

function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          const yOffset = -100; // offset for sticky navbar
          const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}

const HomePage = () => (
  <>
    <Hero />
    <Stats />
    <AudienceStrip />
    <Services />
    <WhyChooseUs />
    <Process />
    <Testimonials />
    <FAQ />
    <CTA />
  </>
);

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { scrollYProgress } = useScroll();

  return (
    <Router>
      <ScrollHandler />
      <div className="min-h-screen bg-gradient-to-b from-gray-50 via-white to-gray-50 dark:from-[#0a0a0a] dark:via-[#0f0f0f] dark:to-[#0a0a0a] text-gray-900 dark:text-white overflow-x-hidden antialiased relative transition-colors duration-300">
        {/* Dot grid */}
        <div className="fixed inset-0 opacity-20 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(14,165,233,0.08) 1px, transparent 0)',
          backgroundSize: '60px 60px'
        }} />

        {/* Cursor glow */}
        <CursorGlow />

        {/* Scroll progress bar */}
        <motion.div
          className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-cyan-500 via-blue-500 to-orange-500 origin-left z-50"
          style={{ scaleX: scrollYProgress }}
        />

        <Navbar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/services/:id" element={<ServiceDetailsPage />} />
        </Routes>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;